// Generated by scripts/theme-config/theme-config.js from api::theme-configuration. Do not edit.

/**
 * Slots de tipografía globales — aplicables a TODOS los bloques, no a
 * uno concreto. Cada constante es `text-style-{slug}` (la clase
 * generada por `generateTextStylesFile`) cuando el tenant pica el
 * campo correspondiente en ThemeConfiguration, o `null` si no.
 */
export const globalEyebrowEstiloClass: string | null = null;
